"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Cuboid, House, Map } from "lucide-react";
export default function AdditionalServices() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    id: 1,
    icon: Cuboid,
    title: "Mapping & 3-D Models",
    description: "High-precision 3-D modeling and digital elevation maps deliver complete spatial data for planning, analysis, and asset management across industries."
  }, {
    id: 2,
    icon: House,
    title: "Low-Slope Roof Inspections",
    description: "Thermal imaging pinpoints moisture intrusion and structural issues on commercial roofs, reducing downtime and extending asset life."
  }, {
    id: 3,
    icon: Map,
    title: "Aerial Surveys",
    description: "Comprehensive aerial surveys capture real-time site conditions, enabling efficient project tracking, reporting, and decision-making."
  }];
  return <section ref={sectionRef} className="relative bg-dark-background text-foreground-dark py-24 overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12">
        <div className={`grid lg:grid-cols-2 gap-12 items-center transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: isVisible ? "0ms" : "0ms"
      }}>
          {}
          <div className="space-y-6">
            {services.map((service, i) => {
            const IconComponent = service.icon;
            return <Card key={service.id} data-index={i} className="bg-dark-background border border-border-strong/20 shadow-medium hover:shadow-strong hover:-translate-y-1 hover:border-accent/40 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group" style={{
              transitionDelay: isVisible ? `${i * 100}ms` : "0ms",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(1rem)"
            }}>
                  <CardHeader>
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors duration-[var(--duration-medium)]">
                        <IconComponent className="w-6 h-6 text-primary group-hover:text-accent transition-colors duration-[var(--duration-medium)]" />
                      </div>
                      <div className="flex-1">
                        <CardTitle className="text-lg text-foreground-dark">
                          {service.title}
                        </CardTitle>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-muted-foreground">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>;
          })}
          </div>

          {}
          <div ref={imageRef} className="relative h-96 lg:h-full rounded-xl overflow-hidden shadow-strong">
            <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
            backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520322/img/aerial_survey_landscape.png)",
            transform: imageVisible ? "scale(1.02)" : "scale(1)"
          }} />
            <div className="absolute inset-0 bg-gradient-to-t from-dark-background/60 to-transparent" />
          </div>
        </div>
      </div>
    </section>;
}